import { loginAxios } from '../boot/axios'
import store from '.'
import { setHeaderToken, removeHeaderToken } from '../utils/auth'
import CryptoJS from 'crypto-js'
export default {
  state: {
    isAuthenticated: false,
    user: null,
    student: null,
    parent: null,
    employee_id: null
  },
  mutations: {
    set_user (state, data) {
      state.user = data
      state.isAuthenticated = true
    },
    set_student (state, data) {
      state.student = data
      state.isAuthenticated = true
    },
    set_parent (state, data) {
      state.parent = data
      state.isAuthenticated = true
    },
    reset_student (state) {
      state.student = null
      state.isAuthenticated = false
    },
    reset_parent (state) {
      state.parent = null
      state.isAuthenticated = false
    },
    reset_user (state) {
      state.user = null
      state.isAuthenticated = false
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.isAuthenticated
    },
    user (state) {
      return state.user
    },
    employee (state) {
      return state.employee_id
    }
  },
  actions: {
    login ({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {
        loginAxios.post('auth/login/', data)
          .then(response => {
            const token = response.data.access_token
            localStorage.setItem('token', token)
            localStorage.setItem('user_id', response.data.user.id)
            localStorage.setItem('username', response.data.user.username)
            localStorage.setItem('name', response.data.user.name)
            localStorage.setItem('roles', response.data.roles)
            localStorage.setItem('loginAs', 'administrator')

            localStorage.setItem('menu', response.data.get_menu)

            const encryptedMessage = CryptoJS.AES.encrypt(localStorage.getItem('roles'), 'amatra1609').toString()
            localStorage.setItem('role', encryptedMessage)

            const aryActiveDoc = response.data.activedoc.toString()
            const encryptedMessageActiveDoc = CryptoJS.AES.encrypt(aryActiveDoc, 'amatra1609').toString()
            localStorage.setItem('docmag', encryptedMessageActiveDoc)

            setHeaderToken(token)
            // commit('reset_user')
            commit('set_user', response.data.user)
            store.dispatch('get_user', token)
            // this.get_user(token)
            resolve(response)
            // this.reload()
          })
          .catch(err => {
            commit('reset_user')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    async get_user ({ commit }) {
      if (!localStorage.getItem('token')) {
        return
      }
      try {
        const response = await loginAxios.get('users/' + localStorage.getItem('user_id'))
        commit('set_user', response.data.data)
      } catch (error) {
        commit('reset_user')
        removeHeaderToken()
        localStorage.removeItem('token')
        return error
      }
    },
    logout ({ commit }) {
      return new Promise((resolve) => {
        commit('reset_user')
        localStorage.removeItem('token')
        localStorage.removeItem('user_id')
        localStorage.removeItem('checkall')
        localStorage.clear()
        removeHeaderToken()
        resolve()
      })
    }
  }
}
